<h2 mat-dialog-title>Download Legacy Incident Data</h2>
<div mat-dialog-content style="min-width: 520px;">

  <div style="margin-bottom: 12px;">
    <div><b>Selected Incident: </b> {{ data.incidentName }}</div>
    <div><b>Unique Fire Identifier: </b> {{ data.uniqueFireIdentifier }}</div>
  </div>
  <div style="margin-bottom: 20px; display: grid; grid-template-columns: 1fr 1fr; gap: 14px;">
    <button mat-raised-button color="primary" class="download-btn" (click)="download('incidentInfo')" [disabled]="isAnyDownloading">
      <mat-icon style="margin-right: 6px;">download</mat-icon> 
      Incident Info
    </button>
    <button mat-raised-button color="primary" class="download-btn" (click)="download('decisions')" [disabled]="isAnyDownloading">
      <mat-icon style="margin-right: 6px;">download</mat-icon> 
      Decisions
    </button>
    <button mat-raised-button color="primary" class="download-btn" (click)="download('analysis')" [disabled]="isAnyDownloading">
      <mat-icon style="margin-right: 6px;">download</mat-icon> 
      Analysis Data
    </button>
    <button mat-raised-button color="primary" class="download-btn" (click)="download('otherIncidentInfo')" [disabled]="isAnyDownloading">
      <mat-icon style="margin-right: 6px;">download</mat-icon> 
      Other Incident Info
    </button>
  </div>
  <div *ngIf="isAnyDownloading" style="margin-bottom: 12px;">
    <mat-progress-bar mode="determinate" [value]="progress"></mat-progress-bar>
    <div style="margin-top: 6px;">Downloading... {{ progress }}%</div> 
  </div>
  <div *ngIf="errorMessage" style="margin-top: 12px; color: red; font-weight: 500;">
    {{ errorMessage }}
   </div> 
   <div *ngIf="largeFileWarning" style="margin-top: 12px; color: black; font-weight: 500;">
    {{ largeFileWarning }}
</div>
<div mat-dialog-actions align="end">
  <button class="primary-button" (click)="close()">Close</button>
</div>